import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../../app-constants";
import { Link } from "gatsby";

function Workflowprocess() {
  return (
    <section className="workflow_process workflow_uk_mob p-100 tekrevol_dark_bg">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>
              Our Lean, Friction-Free App <span>Development Process</span>
            </h2>
            <p>
              Our app development company in the UK uses lean project management
              and agile methodologies to build efficient, fail-safe user-facing
              applications. We ensure fast-tracked projects from concept to
              completion, delivering innovative and adaptable apps.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <div className="workflow_main">
              <div className="workflow_process_item">
                <div className="workflow_process_img">{PlaneIcon}</div>
                <div className="workflow_process_content">
                  <h5>App Conceptualisation & Roadmap</h5>
                  <p>
                    We analyse market trends to craft a detailed development
                    roadmap.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{DesignIcon}</div>
                <div className="workflow_process_content">
                  <h5>App Design & Prototype</h5>
                  <p>
                    Designers create engaging UI/UX and functional prototypes
                    for feedback.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{BuildIcon}</div>
                <div className="workflow_process_content">
                  <h5>Ingenious App Development</h5>
                  <p>
                    We use advanced coding practices to build scalable, secure
                    apps.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{TestIcon}</div>
                <div className="workflow_process_content">
                  <h5>Rigorous Testing & Quality Assurance</h5>
                  <p>
                    Automated testing and QA ensure seamless performance and
                    bug-free apps.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{LaunchIcon}</div>
                <div className="workflow_process_content">
                  <h5>Performance Optimisation</h5>
                  <p>
                    We fine-tune app performance for speed, efficiency, and
                    responsiveness.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{MaintenanceIcon}</div>
                <div className="workflow_process_content">
                  <h5>Deployment & Post-Launch Support</h5>
                  <p>
                    We deploy your app, monitor feedback, and provide ongoing
                    updates.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Workflowprocess;
